import { useFeatureFlag } from './authorization'
import { FEATURE_FLAGS } from '../utils/constants/features.constants'

/**
 * Where the agami form lives for THIS user (06.4): the onde flag routes to the
 * v2, everyone else keeps the paths they have always had.
 *
 * The flag decision belongs HERE — a navigation helper — and nowhere else:
 * neither form contains logic about the other, and at propagation (§10.6) this
 * is the one place to clean up. If the flag ever appeared as a condition inside
 * a view or a form, we would have exactly what the whole epic avoids.
 */
export const useAgamiRoutes = () => {
  const ondeFlag = useFeatureFlag(FEATURE_FLAGS.ONDE)

  return {
    /** The creation form, optionally preselecting a destination experience. */
    newAgamiPath: (experienceId?: string): string => {
      const query = experienceId ? `?addToExperience=${experienceId}` : ''
      return ondeFlag ? `/upload/v2${query}` : `/upload/spot${query}`
    },
    /** The edit form of an existing agami — where 05.4's Open goes. */
    agamiFormPath: (agamiId: string): string => (ondeFlag ? `/spot/v2/${agamiId}` : `/spot/${agamiId}`),
    /** The propose form (v2 only: propose mode does not exist in the v1). */
    proposeAgamiPath: (experienceId: string): string => `/upload/v2?proposeTo=${experienceId}`,
  }
}
